/** True when the event target is a text-entry element, so global keyboard
 * shortcuts (arrow nav, single-key toggles) should stand down and let the field
 * handle the key. */
export function isTextInputTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target.isContentEditable ||
    target.tagName === "INPUT" ||
    target.tagName === "TEXTAREA" ||
    target.tagName === "SELECT"
  );
}
